import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {Box, Button, Flex} from '@salesforce/retail-react-app/app/components/shared/ui'
import {LeftArrow} from '../../icons'
import {renderLayoutsSwitch, renderComponentsSwitch} from '../../optimizely/utils/contentRenderer'
import {resolveSizeGuideBlocks} from '../../../utils/size-guide-utils'

const QuickViewSizeChart = ({optimizelyContent, sizeChartId, onBack}) => {
    const sizeGuideContentItems = useMemo(
        () => resolveSizeGuideBlocks(optimizelyContent?.item?.SizeGuides, sizeChartId),
        [optimizelyContent, sizeChartId]
    )

    return (
        <Flex width="100%" height="100%" flexDirection="column">
            <Box px={4} py={4}>
                <Button
                    variant="unstyled"
                    onClick={onBack}
                    display="flex"
                    alignItems="center"
                    height={'24px'}
                    width={'24px'}
                    minW={'auto'}
                    aria-label="Back to quick view"
                >
                    <LeftArrow />
                </Button>
            </Box>
            <Box flex="1" overflowY="auto" px={4} pb={4}>
                {sizeGuideContentItems.map((item, i) => {
                    const exp = item?.ContentLink?.Expanded
                    if (!exp) return null
                    return (
                        <React.Fragment key={exp?.ContentLink?.GuidValue ?? i}>
                            {renderLayoutsSwitch(exp) || renderComponentsSwitch(exp)}
                        </React.Fragment>
                    )
                })}
            </Box>
        </Flex>
    )
}

QuickViewSizeChart.propTypes = {
    optimizelyContent: PropTypes.object,
    sizeChartId: PropTypes.string,
    onBack: PropTypes.func
}

export default QuickViewSizeChart
